import React, { useState, useEffect } from 'react';
import { Grid, Container } from '@material-ui/core';
import { node } from 'prop-types';

const ImageContainer = ({ children, ...props }) => {
  const [isMobile, setIsMobile] = useState(false);

  const resize = () => {
    if (window !== 'undefined') {
      setIsMobile(window.innerWidth < 499);
    }
  };

  useEffect(() => {
    if (window) {
      window.addEventListener('resize', resize);
      setIsMobile(window.innerWidth < 499);
    }
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  return isMobile ? (
    <Grid container {...props} spacing={0}>{children}</Grid>
  ) : (
    <Container>
      <Grid container {...props}>{children}</Grid>
    </Container>
  );
};

ImageContainer.propTypes = {
  children: node.isRequired,
};

export default ImageContainer;
